import React from 'react';

const Monitor = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.75"
      y="2.75"
      width="12.5"
      height="8.5"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M5.333 14h5.334M8 11.25V14"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Monitor;
